/* storybook-check-ignore */
import * as React from 'react';

import { Box } from '@opendoor/bricks/core';

export interface IContactInfoProps {
  email: string;
  name: string;
  onClick?: () => void;
  organization?: string;
  phone: string;
}

const ContactInfo: React.FC<IContactInfoProps> = (props) => (
  <Box color="neutrals100" my={7} mx={0}>
    {props.organization ? <b>{props.organization}</b> : null}
    <div>{props.name}</div>
    <a href={`mailto:${props.email}`} onClick={props.onClick}>
      {props.email}
    </a>
    <div>{props.phone}</div>
  </Box>
);

export default ContactInfo;
